import React from 'react';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Container,
  Divider,
  makeStyles,
  Typography,
  useTheme,
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

import Plano from '../../interfaces/Plano';
import { PlanoContext } from './PlanoContextProvider';
import { formatPriceBR } from './utils';
interface PlanoCardProps {
  plano: Plano;
}

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    flexShrink: 1,
    flexBasis: 'fit-content',
    height: 'fit-content',
    margin: '0 0.5em',
    '&:first-child': {
      marginLeft: 0,
    },
    '&:last-child': {
      marginRight: 0,
    },
    [theme.breakpoints.up('md')]: {
      flexBasis: 1,
      flexGrow: 2,
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 'fit-content',
    },
  },
  content: {},
  meta: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-around',
  },
  actionArea: {
    paddingTop: '.5em',
    paddingBottom: '.5em',
    textAlign: 'center',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
  },
  separator: {
    margin: '0 1em',
    [theme.breakpoints.up('md')]: {
      margin: 'initial',
    },
  },
  totalValueText: {
    fontSize: '1em',
    marginLeft: '0.6em',
  },
  discountValueText: {
    fontSize: '1.5em',
    marginLeft: '0.2em',
    textAlign: 'right',
  },
}));

export default function PlanoCard(props: PlanoCardProps) {
  useTheme();
  const classes = useStyles();

  const plano: Plano = props.plano;

  const mensagemContato = `Olá! Estou insteressado(a) em saber mais sobre o plano de ${plano.velocidade}.`;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Box className={classes.meta}>
          <Typography variant="h6">{plano.velocidade}</Typography>
          <Divider
            className={classes.separator}
            orientation="vertical"
            variant="fullWidth"
            light
            flexItem
          />
          <Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
              }}
            >
              <Typography variant="subtitle2">De: </Typography>
              <Typography className={classes.totalValueText} variant="h6">
                { formatPriceBR(plano.valorTotal!) }
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="subtitle2">Por: </Typography>
              <Typography className={classes.discountValueText} variant="h5">
                { formatPriceBR(plano.valorDesconto!) }
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
      <PlanoContext.Consumer>
        {(context: any) => (
          <CardActionArea
            className={classes.actionArea}
            onClick={() => context.setMensagemContato(mensagemContato)} // eslint-disable-line @typescript-eslint/no-unused-vars
          >
            <Container>
              <Typography variant="button">Saber Mais</Typography>
            </Container>
          </CardActionArea>
        )}
      </PlanoContext.Consumer>
    </Card>
  );
}
